import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function ExerciseRequestCreatedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const {
    data: {
      exercise_request: { name, requester }
    }
  } = notification;

  return (
    <NotificationRowContent
      notification={notification}
      // El solicitante llega con `name`; el avatar saca las iniciales de `full_name`.
      user={{ ...requester, full_name: requester.name }}
      title={requester.name}
      body={t('exercise.created.body', { name, requester: requester.name, ns: 'notifications' })}
    />
  );
}

ExerciseRequestCreatedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      exercise_request: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        requester: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          photo: PropTypes.string
        }).isRequired
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default ExerciseRequestCreatedNotification;
